import styled from 'styled-components'
import { customMedia } from '../customMedia'

export const PcBr = styled.br`
  ${customMedia.lessThan("medium")`
    display: none;
  `}
`